import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { flowNodeColor } from 'fable/flowEditor';
import { Text } from 'flow-builder/node/text';
import { TextContent } from 'flow-builder/node/textContent';
import { TextEllipsis } from 'flow-builder/node/textEllipsis';
import { hexStringToNumber } from 'flow-builder/renderers/common/colors';
import { IVR as IVRModal } from '../../modals/ivr';
import { useAnnouncementName } from './callback';
const translatePayload = (node) => {
    const { buttons } = node.payload;
    return Object.keys(buttons).map((key) => ({
        id: uuid(),
        connection: buttons[key].nodeId,
        label: `Press ${buttons[key].button}`,
    }));
};
const updateConnection = (node, connection, connectionId) => {
    const payload = Object.assign({}, node.payload);
    const buttons = Object.assign({}, payload.buttons);
    const updatedButton = Object.keys(buttons).find((key) => buttons[key].nodeId === connection.id);
    if (!updatedButton) {
        return node;
    }
    buttons[updatedButton] = Object.assign(Object.assign({}, buttons[updatedButton]), { nodeId: connectionId });
    if (buttons[updatedButton].nodeId === node.payload.default_node_id) {
        payload.default_node_id = connectionId;
    }
    return Object.assign(Object.assign({}, node), { payload: Object.assign(Object.assign({}, payload), { buttons }) });
};
export const IVRNodeAttributes = {
    iconName: 'th',
    label: 'IVR',
    helpText: 'Give incoming callers options to choose from using their dial pad before talking to an agent.',
    color: hexStringToNumber(flowNodeColor.purple),
    translatePayload,
    updateConnection,
    NodeContent: IVRNode,
    ActionModal: IVRModal,
};
export function IVRNode({ node, context }) {
    const { extraData } = context;
    const { payload } = node;
    const announcement = useAnnouncementName(payload.announcement, extraData);
    return (_jsx(TextContent, { children: useMemo(() => (_jsxs(TextEllipsis, { children: [_jsx(Text, { weight: "normal", text: "Announcement" }), _jsx(Text, { weight: "semibold", text: announcement })] })), [announcement]) }));
}
